import { type ReactNode, createContext, useCallback, useEffect, useState } from 'react';
import { type AppPreviewContextType } from '@/types';
import { convertFileToBase64 } from '@/helpers';
import { useGlobalSettings } from '@/hooks';

const defaultAppPreviewContext: AppPreviewContextType = {
  previewImageUrl: null,
  setPreviewImage: () => {
    console.warn('setPreviewImageUrl called outside AppPreviewProvider');
  },
};

const AppPreviewContext = createContext(defaultAppPreviewContext);

export { AppPreviewContext };

export const AppPreviewProvider = ({ children }: { children: ReactNode | ReactNode[] }) => {
  const [previewImageUrl, setPreviewImageUrl] = useState<string | null>(null);
  const { currentChurch } = useGlobalSettings();

  const setPreviewImage = useCallback((newImage: File | null) => {
    if (!newImage) {
      setPreviewImageUrl(null);
      return;
    }
    convertFileToBase64(newImage)
      .then((dataUrl: string) => setPreviewImageUrl(dataUrl))
      .catch(() => setPreviewImageUrl(null));
  }, []);

  useEffect(() => {
    // Clear any staged preview image when church changes to reveal the new church default image
    setPreviewImageUrl(null);
  }, [currentChurch?.churchId]);

  return (
    <AppPreviewContext.Provider value={{ previewImageUrl, setPreviewImage }}>{children}</AppPreviewContext.Provider>
  );
};
